export const enviornment = {
  baseUrl: "https://c2glue.com/api/foamtree/Api/",
};
